<template>
    <div>
<!--      <div class="alert alert-danger" role="alert">-->
<!--        V noci 11.11.2020 došlo k výpadku spojení. V 9:19 bylo spojení obnoveno. Spotřeba naměřená během této doby se projeví v grafech souhrnně v 9:19-->
<!--      </div>-->
        <h1 v-if="availableOrganizations.length === 1">{{activeOrganization.name}}</h1>
        <h1 v-if="availableOrganizations.length > 1">
            <div class="flex flex-wrap items-center gap-2">
                <div class="w-full lg:w-1/4">
                    <select class="form-control" v-model="activeOrganization">
                        <option v-for="org in availableOrganizations" v-bind="activeOrganization" :value="org">
                            {{org.name}}
                        </option>
                    </select>
                </div>
                <div class="btn-group" role="group" v-if="organizationOrderingEnabled && activeOrganizationOrdering && activeOrganizationOrdering.owner">
                    <b-btn type="default" :disabled="!activeOrganizationOrdering.canMoveUp || movingOrganization" @click="moveOrganization('up')" v-b-tooltip="$t('message.move_up')">
                        <i class="fa fa-arrow-up"></i>
                    </b-btn>
                    <b-btn type="default" :disabled="!activeOrganizationOrdering.canMoveDown || movingOrganization" @click="moveOrganization('down')" v-b-tooltip="$t('message.move_down')">
                        <i class="fa fa-arrow-down"></i>
                    </b-btn>
                </div>
            </div>
        </h1>
        <alerts :unit="selectedUnit"/>
        <div v-if="isUserOwnerOfActiveOrganization" class="action-buttons flex flex-wrap items-center gap-2">
<!--            <create-building :unit="selectedUnit"/>-->
<!--            <create-unit :unit="selectedUnit"/>-->
            <create-transmitter :active="active" />
            <create-homebase @click="reloadUser"/>
        </div>
        <br>
        <b-tabs :value="tabIndex" @change="selectUnit">
            <b-tab tab-key="total" :title="'Σ ' + $t('message.total_water')" :active="active==='total'" html-title></b-tab>
            <b-tab tab-key="cold" :title="'<i class=\'fa fa-tint cold-water\'></i> ' + $t('message.cold_water')" :active="active==='cold'" html-title></b-tab>
            <b-tab tab-key="hot" :title="'<i class=\'fa fa-tint hot-water\'></i> ' + $t('message.hot_water')" :active="active==='hot'" html-title></b-tab>
            <b-tab tab-key="power" :title="'<i class=\'fa fa-bolt power\'></i> ' + $t('message.electricity')" :active="active==='power'" html-title></b-tab>
            <b-tab tab-key="gas" :title="'<i class=\'fa fa-fire gas\'></i> ' + $t('message.gas')" :active="active==='gas'" html-title></b-tab>
            <b-tab tab-key="heat" :title="'<i class=\'fa fa-thermometer-three-quarters heat\'></i> ' + $t('message.heat')" :active="active==='heat'" html-title></b-tab>
        </b-tabs>
        <DashboardHeatmap :key="active" :type="active" :data="heatmapData"/>
        <DashboardHead
            :unit="headUnit"
            :type="active"
            :filter-date="filterDate"
            :filter-period="filterPeriod"
        />
        <DashboardTable v-if="active=='total'" :key="'table-total'" unit="liters" type="total" medium="water" :period="period" :data="dashboardDataWater"/>
        <DashboardTable v-if="active=='cold'" :key="'table-cold'" unit="liters" type="cold" medium="water" :period="period" :data="dashboardDataWater"/>
        <DashboardTable v-if="active=='hot'" :key="'table-hot'" unit="liters" type="hot" medium="water" :period="period" :data="dashboardDataWater"/>
        <DashboardTable v-if="active=='power'" :key="'table-power'" unit="watts" type="cold" medium="power" :period="period" :data="dashboardDataPower"/>
        <DashboardTable v-if="active=='gas'" :key="'table-gas'" unit="liters" type="cold" medium="gas" :period="period" :data="dashboardDataGas"/>
        <DashboardTable v-if="active=='heat'" :key="'table-heat'" unit="watts" type="cold" medium="heat" :period="period" :data="dashboardDataHeat"/>
    </div>
</template>

<script>
    import moment from 'moment'
    import 'moment-timezone'
    import _ from 'lodash'
    import axios from 'axios'
    import mixins from '../modules/mixins'
    import DashboardHeatmap from './dashboard/DashboardHeatmap'
    import DashboardHead from './dashboard/DashboardHead'
    import DashboardTable from './dashboard/DashboardTable'
    import Alerts from './dashboard/Alerts'
    import {CreateBuilding, CreateUnit, CreateTransmitter, CreateHomebase} from './dashboard/modal'
    import storage, {HEATMAP_REQUEST, DASHBOARD_REQUEST, ORGANIZATION_REQUEST, USER_REQUEST} from '../_store'
    import eventBus from '../modules/eventBus'
    import {
        DASHBOARD_TABS,
        dashboardQueryChanged,
        defaultDashboardDate,
        headUnitForTab,
        parseDashboardPeriod,
        parseDashboardQuery,
        tabIndex as dashboardTabIndex,
        unitForTab
    } from '../_helper/dashboardQuery'

    export default {
        name: 'Tab',
        components: {
            DashboardHeatmap,
            DashboardHead,
            DashboardTable,
            CreateBuilding,
            CreateUnit,
            CreateTransmitter,
            CreateHomebase,
            Alerts
        },
        data () {
            return {
                cache: {},
                loading: {},
                dashboardDataWater: [],
                dashboardDataPower: [],
                dashboardDataGas: [],
                dashboardDataHeat: [],
                heatmapData: {},
                lastRequest: {},
                selectedUnit: 'liters',
                period: 'day',
                filterDate: '',
                filterPeriod: 'day',
                active: 'total',
                movingOrganization: false,
                organizationOrderingEnabled: false
            }
        },
        computed: {
            activeOrganizationOrdering () {
                if (!this.activeOrganization) {
                    return null
                }
                return this.availableOrganizations.find(organization => organization.id === this.activeOrganization.id) || null
            },
            tabIndex () {
                return dashboardTabIndex(this.active)
            },
            headUnit () {
                return headUnitForTab(this.active)
            }
        },
        mixins: [mixins],
        watch: {
            '$route.query': {
                deep: true,
                handler () {
                    this.applyRouteQuery()
                }
            }
        },
        methods: {
            init () {
                this.loadHeatmap()
                this.applyRouteQuery()
                storage.dispatch(ORGANIZATION_REQUEST, {action: 'read', current: false})
            },
            parseCurrentQuery () {
                const timezone = this.activeOrganization && this.activeOrganization.timezone
                const now = timezone ? moment().tz(timezone) : moment()
                const period = parseDashboardPeriod(this.$route.query.period, 'day')
                return parseDashboardQuery(this.$route.query, {
                    period: 'day',
                    date: defaultDashboardDate(period, now)
                })
            },
            applyRouteQuery () {
                const parsed = this.parseCurrentQuery()
                const tabChanged = parsed.tab !== this.active
                const periodChanged = parsed.period !== this.filterPeriod
                const dateChanged = parsed.date !== this.filterDate
                const organizationId = this.activeOrganization && this.activeOrganization.id
                const organizationChanged = this.lastRequest.organization !== organizationId
                if (!tabChanged && !periodChanged && !dateChanged && !organizationChanged) {
                    return
                }
                this.active = parsed.tab
                this.selectedUnit = unitForTab(parsed.tab)
                this.filterPeriod = parsed.period
                this.filterDate = parsed.date
                this.period = parsed.period
                this.loadStructure({
                    type: parsed.tab,
                    period: parsed.period,
                    date: parsed.date,
                    reload: true,
                    force: tabChanged
                })
            },
            pushDashboardQuery (patch) {
                const query = Object.assign({}, this.$route.query, patch)
                Object.keys(query).forEach((key) => {
                    if (query[key] === undefined || query[key] === null || query[key] === '') {
                        delete query[key]
                    }
                })
                if (!dashboardQueryChanged(this.$route.query, query)) {
                    return Promise.resolve()
                }
                return this.$router.push({ query }).catch(() => {})
            },
            selectUnit (index) {
                const type = DASHBOARD_TABS[index]
                if (!type) {
                    return
                }
                this.pushDashboardQuery({ tab: type })
            },
            reloadUser () {
                this.storage.dispatch(USER_REQUEST, {action: 'read'}).then(response => {})
            },
            moveOrganization (direction) {
                const organization = this.activeOrganizationOrdering
                if (!organization || this.movingOrganization || (direction === 'up' ? !organization.canMoveUp : !organization.canMoveDown)) {
                    return
                }
                this.movingOrganization = true
                axios.put('/api/v2/tree-order', {
                    type: 'organization',
                    id: organization.id,
                    direction
                }).then(() => {
                    return storage.dispatch(ORGANIZATION_REQUEST, {action: 'read', current: false})
                }).catch(err => {
                    this.notify('danger', this.getErrorMessage(err))
                }).finally(() => {
                    this.movingOrganization = false
                })
            },
            loadHeatmap () {
                storage.dispatch(HEATMAP_REQUEST, this.activeOrganization.id).then((response) => {
                    const data = response.data.data
                    data.organization = this.activeOrganization.id
                    this.heatmapData = data
                }).catch(err => {
                    if (err.response.status === 403) {
                        storage.dispatch(ORGANIZATION_REQUEST, {action: 'read'})
                            .then(() => {
                                this.$router.go('/')
                            })
                    }
                })
            },
            loadStructure (request = {}) {
                // this.stopInterval()
                const requestedType = request.type
                const defaultOptions = {
                    period: this.filterPeriod || 'day',
                    date: this.filterDate || defaultDashboardDate(this.filterPeriod || 'day', this.activeOrganization && this.activeOrganization.timezone ? moment().tz(this.activeOrganization.timezone) : moment()),
                    force: false,
                    organization: this.activeOrganization.id,
                    type: this.active
                }
                request = _.defaults(request, defaultOptions)
                if (request.reload === true) {
                    const force = request.force
                    request = Object.assign({}, this.lastRequest || {}, request)
                    request.force = force || request.force
                    request = _.defaults(request, defaultOptions)
                }
                const viewType = requestedType || request.type || request.viewType || this.active
                request.type = this.resolveApiType(viewType)
                request.viewType = viewType
                this.period = request.period
                switch (request.period) {
                case 'hour':
                    if (!((request.date.match(/\./g) || []).length === 2 && (request.date.match(/-/g) || []).length === 1)) {
                        return
                    }
                    break
                case 'day':
                    if (!((request.date.match(/\./g) || []).length === 2 && (request.date.match(/-/g) || []).length === 0)) {
                        return
                    }
                    break
                case 'month':
                    if ((request.date.match(/\./g) || []).length !== 1) {
                        return
                    }
                    break
                case 'year':
                    if ((request.date.match(/\./g) || []).length !== 0) {
                        return
                    }
                    break
                }
                request.timezone = this.activeOrganization.timezone

                const key = this.hash(request)
                const cached = this.cache[key]
                if (!request.force && cached) {
                    this.lastRequest = request
                    eventBus.emit('loading-state', {
                        state: false,
                        date: request.date,
                        period: request.period,
                        organization: this.activeOrganization.id,
                        type: request.viewType || request.type
                    })
                    this.applyDashboardData(cached)
                    return
                }
                if (this.loading[key]) {
                    return
                }
                this.loading[key] = true
                eventBus.emit('loading-state', {
                    state: true,
                    date: request.date,
                    period: request.period,
                    organization: this.activeOrganization.id,
                    type: request.viewType || request.type
                })
                this.lastRequest = request
                const apiRequest = Object.assign({}, request)
                delete apiRequest.viewType
                storage.dispatch(DASHBOARD_REQUEST, apiRequest).then((response) => {
                    eventBus.emit('loading-state', {state: false})
                    const data = response.data
                    this.applyDashboardData(data)
                    this.cache[key] = data
                    this.loading[key] = false
                }).catch((err) => {
                    this.loading[key] = false
                    this.notify('danger', err.response.data.message)
                })
            },
            applyDashboardData (data = {}) {
                if (Object.prototype.hasOwnProperty.call(data, 'water')) {
                    this.dashboardDataWater = data.water
                }
                if (Object.prototype.hasOwnProperty.call(data, 'power')) {
                    this.dashboardDataPower = data.power
                }
                if (Object.prototype.hasOwnProperty.call(data, 'gas')) {
                    this.dashboardDataGas = data.gas
                }
                if (Object.prototype.hasOwnProperty.call(data, 'heat')) {
                    this.dashboardDataHeat = data.heat
                }
            },
            resolveApiType (type) {
                if (['total', 'cold', 'hot', 'water'].indexOf(type) > -1) {
                    return 'water'
                }
                if (['power', 'gas', 'heat', 'all'].indexOf(type) > -1) {
                    return type
                }
                return 'all'
            },
            hash (request) {
                // Stable cache key without object-hash (Node crypto / browserify breaks under Vite ESM)
                return [
                    request.organization,
                    request.period,
                    request.date,
                    request.period === 'day' ? '-' + request.timezone : 'UTC',
                    request.type
                ].join('|')
            }
        },
        created () {
            this.stopChangeListener = eventBus.on('change', (request = {}) => {
                if (request.force || request.reload) {
                    this.loadStructure(request)
                    return
                }
                const patch = {}
                if (request.date) {
                    patch.date = request.date
                }
                if (request.period) {
                    patch.period = request.period
                }
                if (Object.keys(patch).length === 0) {
                    this.loadStructure(request)
                    return
                }
                this.pushDashboardQuery(patch)
            })
            this.init()
            this.$store.dispatch(USER_REQUEST, {action: 'read'}).then(response => {})
        },
        beforeUnmount () {
            this.stopChangeListener()
        }
    }
</script>

<style scoped>
    .action-buttons {
        margin-top: 0.5rem;
        margin-bottom: 4px;
    }
    .action-buttons section {
        display: inline-block;
        line-height: normal;
        vertical-align: middle;
    }
    .action-buttons >>> .btn {
        line-height: 1;
        vertical-align: middle;
    }
</style>
